/**
 * Created by Carsten Bühler
 * User: CBuehler on 23.10.2015
 * Copyright: xdot GmbH 2015
 */

export const validate = (formData, fields) => Object.keys(fields).reduce((result, prop) => {
    const f = fields[ prop ];
    result[ prop ] = f.validFn(f.label, formData[ prop ]);
    return result;
}, {});

export const isFormValid = (formValidation) => {
    let formValid = true;
    if (formValidation) {
        Object.keys(formValidation).forEach(propName => {
            if (formValidation[ propName ]) {
                formValid = false;
            }
        });
    }
    return formValid;
};

export const onChangeHandler = (getProps, validate, handler = {}) => {
    return (propName) => {
        return handler[ propName ] || (handler[ propName ] = e => {
            const props = getProps(), newData = {
                ...props.formData,
                [ propName ]: (e && e.target) ? e.target.value : e
            };
            props.onChange(newData, validate ? validate(newData) : undefined);
        });
    }
};

export function validateStringMinLengthMaxLength(value, minLength, maxLength, fieldLabel) {
    let valid;

    if (minLength <= 0) {
        if (value) {
            if (!(value.length <= maxLength)) {
                valid = fieldLabel + ' zu lang. Maximal ' + maxLength + ' Zeichen.';
            }
        }
    } else {
        if (!(value && value.length >= minLength)) {
            valid = 'Bitte ' + fieldLabel + ' eingeben!';
        }

        if ((value && value.length >= minLength && !/\S/.test(value))) {
            valid = fieldLabel + ' darf nicht mit einem Leerzeichen starten!';
        }

        if ((value && value.length >= minLength) && !(value.length <= maxLength)) {
            valid = fieldLabel + ' zu lang. Maximal ' + maxLength + ' Zeichen.';
        }
    }

    return valid;
}

export const minMax = (minLength, maxLength) => (label, value) => {
    let valid;

    if (minLength <= 0) {
        if (value) {
            if (!(value.length <= maxLength)) {
                valid = label + ' zu lang. Maximal ' + maxLength + ' Zeichen.';
            }
        }
    } else {
        if (!(value && value.length >= minLength)) {
            valid = 'Bitte ' + label + ' eingeben!';
        }

        if ((value && value.length >= minLength && !/\S/.test(value))) {
            valid = label + ' darf nicht mit einem Leerzeichen starten!';
        }

        if ((value && value.length >= minLength) && !(value.length <= maxLength)) {
            valid = label + ' zu lang. Maximal ' + maxLength + ' Zeichen.';
        }
    }
    return valid;
};

export const minMax_0_75 = minMax(0, 75);
export const minMax_1_75 = minMax(1, 75);
export const minMax_0_500 = minMax(0, 500);


export const isFiniteNumber = (label, v) =>
     (!isFinite(v)) ? label + ' muss eine Zahl sein!': undefined;

export const isPositiveFiniteNumber = (label, v) =>
     (!isFinite(v) || v < 0) ? label + ' muss eine positive Zahl sein!': undefined;

export const exists = (label, v) =>
     (typeof v === 'undefined' || v === '' || v === null || v === "null") ? 'Bitte ' + label + ' eingeben!': undefined;

export const selected = (label, v) =>
    (typeof v === 'undefined' || v === '' || v === null || v === "null") ? 'Bitte ' + label + ' auswählen!': undefined;

export const min_2_Selected = (label, v) =>
    (!v || !v.length || v.length < 2) ? `Bitte mindestens ${2} ${label} auswählen!`: undefined;



// WEBPACK FOOTER //
// ./js/utils/form-validation-util.js